import React from "react";
import { Navigate } from "react-router-dom";
import {
  isLegacySettingsEnabled,
  SETTINGS_HOME_PATH,
} from "../../config/featureFlags";

/**
 * Blocks legacy settings routes when REACT_APP_LEGACY_SETTINGS_ENABLED is off.
 */
export default function LegacySettingsGuard({ children }) {
  if (!isLegacySettingsEnabled) {
    return <Navigate to={SETTINGS_HOME_PATH} replace />;
  }

  return children;
}
